import { type UseControllerProps, type FieldValues, useController } from 'react-hook-form';

import { NumberInput, type NumberInputProps } from '../NumberInput';

type FormNumberInputProps<TFieldValues extends FieldValues = FieldValues> =
  UseControllerProps<TFieldValues> & NumberInputProps;

function FormNumberInput<TFieldValues extends FieldValues = FieldValues>(
  props: FormNumberInputProps<TFieldValues>,
) {
  const {
    field: { ref, ...field },
    fieldState: { error },
  } = useController({ ...props, name: props.name });

  return (
    <NumberInput
      {...props}
      {...field}
      error={!!error}
      helperText={error?.message ?? props.helperText}
      required={Boolean(props.rules?.required ?? props.required)}
      inputRef={ref}
      onChange={(event) => {
        field.onChange(event.target.value ?? null);
        props.onChange?.(event);
      }}
    />
  );
}

export type { FormNumberInputProps };
export { FormNumberInput };
